import { render, staticRenderFns } from "./post-content.vue?vue&type=template&id=1fd6dd16&lang=pug&"
import script from "./post-content.vue?vue&type=script&lang=js&"
export * from "./post-content.vue?vue&type=script&lang=js&"
import style0 from "./post-content.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports